<template>
  <div
    class="org-List"
    :class="{
      'h5-org-List': isH5,
      'web-org-list': !isH5,
      'electron-org-list': isElectron,
    }"
  >
    <!-- 标题区域 -->
    <SectionHeader
      title="优选教育机构"
      subtitle="汇聚行业顶尖机构，提供权威教学服务"
    />

    <div class="flex overflow-x-auto snap-x snap-mandatory md:grid md:grid-cols-2 md:gap-6 no-scrollbar">
      <div
        v-for="org in showOrgList"
        :key="org.id"
        class="min-w-[85vw] sm:min-w-[45vw] md:min-w-0 snap-start group bg-white dark:bg-slate-800 rounded-4xl flex flex-col shadow-soft dark:shadow-none transition-all duration-300 relative overflow-hidden cursor-pointer hover:-translate-y-1 hover:shadow-[0_20px_40px_-4px_rgba(0,0,0,0.08)] dark:hover:shadow-[0_20px_40px_-4px_rgba(0,0,0,0.3)] dark:border dark:border-slate-700"
      >
        <div class="pt-6 px-6 pb-2 flex-1 flex justify-between items-start">
          <div class="flex gap-4 flex-1 min-w-0 cursor-pointer" @click="jumpUrl(`/org/${org.org.org_id}`)">
            <div class="w-14 h-14 rounded-xl shadow-sm bg-white dark:bg-slate-700 p-1 flex-shrink-0">
              <img class="w-full h-full object-cover rounded-lg" :src="handlerOrgLogo(org.org.org_logo)" alt="" />
            </div>
            <div class="min-w-0 flex-1">
              <h3 class="md:text-lg font-black text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="overflow-hidden text-ellipsis whitespace-nowrap">{{ org.org.org_name }}</span>
                <span class="p-1 bg-blue-50 dark:bg-blue-900/30 rounded-full text-blue-500 dark:text-blue-400 flex-shrink-0 inline-flex">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
                    <path d="M9 22v-4h6v4" />
                    <path d="M8 6h.01" />
                    <path d="M16 6h.01" />
                    <path d="M12 6h.01" />
                    <path d="M12 10h.01" />
                    <path d="M12 14h.01" />
                    <path d="M16 10h.01" />
                    <path d="M16 14h.01" />
                    <path d="M8 10h.01" />
                    <path d="M8 14h.01" />
                  </svg>
                </span>
              </h3>
              <div class="flex items-center gap-3 mt-1 text-xs font-medium text-slate-500 dark:text-slate-400">
                <span v-if="org.org.rating" class="inline-flex items-center gap-1 bg-amber-50 dark:bg-amber-900/20 py-0.5 px-1.5 rounded text-amber-600 dark:text-amber-400 flex-shrink-0">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  {{ org.org.rating || '4.8' }}
                </span>
                <span v-if="org.student_count_show === 1" class="overflow-hidden text-ellipsis whitespace-nowrap">
                  {{ million(org.student_count) }} 学员
                </span>
              </div>
              <!-- 机构描述 -->
              <p v-if="org.org.org_desc" class="mt-2 text-sm text-slate-500 dark:text-slate-400 leading-relaxed line-clamp-2">
                {{ org.org.org_desc }}
              </p>
              <!-- 统计标签 -->
              <div class="flex gap-2 mt-3">
                <span class="bg-slate-50 dark:bg-slate-700 text-slate-600 dark:text-slate-300 text-[10px] font-bold py-1 px-2 rounded">{{ org.course_count || '10+' }} 门好课</span>
                <span class="bg-slate-50 dark:bg-slate-700 text-slate-600 dark:text-slate-300 text-[10px] font-bold py-1 px-2 rounded">官方认证</span>
              </div>
            </div>
          </div>
          <button class="w-9 h-9 rounded-full bg-slate-50 dark:bg-slate-700 border-none flex items-center justify-center text-slate-400 cursor-pointer transition-all duration-300 flex-shrink-0 shadow-sm group-hover:bg-slate-900 dark:group-hover:bg-brand-500 group-hover:text-white" @click="jumpUrl(`/org/${org.org.org_id}`)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14m-7-7 7 7-7 7"/>
            </svg>
          </button>
        </div>

        <!-- 精选课程推荐条 -->
        <div v-if="org.course_list && org.course_list.length" class="mt-auto mx-2 mb-2">
          <div class="bg-slate-50 dark:bg-slate-700/50 rounded-3xl p-3 flex items-center gap-3 cursor-pointer border border-transparent transition-all duration-300 hover:bg-brand-50 dark:hover:bg-brand-900/20 hover:border-brand-100 dark:hover:border-brand-800" @click="goDetail(org.course_list[0].id)">
            <div class="w-16 h-12 rounded-xl overflow-hidden flex-shrink-0 shadow-sm">
              <img
                class="w-full h-full object-cover"
                :src="org.course_list[0].cover_url + '?imageView2/0/w/200'"
                alt=""
              />
            </div>
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-1 mb-0.5">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-brand-500">
                  <path d="M12 3l1.5 4.5H18l-3.5 2.5L16 14.5 12 11.5 8 14.5l1.5-4.5L6 7.5h4.5z" fill="currentColor" />
                </svg>
                <span class="text-[10px] font-bold text-brand-500 uppercase tracking-wide">精选推荐</span>
              </div>
              <h4 class="md:text-xs font-bold text-slate-800 dark:text-slate-200 overflow-hidden text-ellipsis whitespace-nowrap transition-colors duration-300">{{ org.course_list[0].course_name }}</h4>
            </div>
            <div v-if="org.course_list[0].goods" class="md:pr-3 flex items-center md:gap-1.5">
              <span v-if="org.course_list[0].goods.fee_type === 1" class="text-sm font-black text-brand-500">免费</span>
              <template v-else>
                <Price
                  size="SL1"
                  :activePrice="getCoursePrice(org.course_list[0]).activePrice"
                  :originPrice="getCoursePrice(org.course_list[0]).originPrice"
                />
                <span v-if="getCoursePrice(org.course_list[0]).activityText" class="text-[10px] font-bold text-red-500 bg-red-50 dark:bg-red-900/20 dark:text-red-400 px-1.5 py-0.5 rounded border border-red-100 dark:border-red-800 whitespace-nowrap">
                  {{ getCoursePrice(org.course_list[0]).activityText }}
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { million } from "@saas/components/src/utils/utils";
import { isH5, isMobile, getCdnUrl } from "@saas/components/src";
import { mapGetters } from "vuex";
import SectionHeader from "./SectionHeader.vue";
import Price from "@saas/components/src/components/price/Index.vue";
export default {
  props: {
    orgList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: function () {
    return {
      million,
      isMobile: isMobile(),
      isH5: isH5(),
      isElectron: window.isElectron,
    };
  },
  methods: {
    jumpUrl(url) {
      if (window.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    goDetail(id) {
      let url = `/product-detail/${id}`;
      if (window.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    getCoursePrice(course) {
      const goods = course.goods || {};
      let originPrice = goods.price || null;
      let activePrice = null;
      let activityText = '';

      if (course.promotion_info?.id) {
        activePrice = course.promotion_info.promotion_price;
        activityText = '促销中';
      } else if (course.group_buy_info?.id) {
        activePrice = course.group_buy_info.price;
        activityText = '拼团';
      } else if (course.union?.id) {
        activityText = '联报';
      } else if (course.coupon_info?.id && course.coupon_info.distribution_method === 1) {
        const { coupon_type, amount, ratio } = course.coupon_info;
        if (coupon_type === 1) {
          activePrice = originPrice - amount;
        } else {
          activePrice = Math.round(originPrice * ratio / 100);
        }
        activityText = '领券优惠';
      }

      return { originPrice, activePrice, activityText };
    },
    handleClickAllCourse(org_id) {
      if (this.$route.query && this.$route.query.inReview === "1") {
        this.jumpUrl(`/org-courses/${org_id}?inReview=1`);
      } else {
        this.jumpUrl(`/org-courses/${org_id}`);
      }
    },
    handlerOrgLogo(url) {
      if (!url) {
        return getCdnUrl("/cdn/static/images/default_org_logo.png", "?imageView2/0/w/100", "comettech");
      } else {
        return url + "?imageView2/0/w/100";
      }
    },
  },
  watch: {},
  computed: {
    ...mapGetters(["user"]),
    showOrgList() {
      return this.orgList.filter((item) => {
        return item.course_list?.length;
      });
    },
  },
  components: {
    SectionHeader,
    Price,
  },
};
</script>

<style lang="scss" scoped>
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.org-List {
  .line-clamp-2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}

// 使用 CSS 变量（仅桌面端）
@media (min-width: 768px) {
  .org-List {
    .flex.overflow-x-auto {
      gap: var(--card-gap, 1.5rem);
    }
    .snap-start {
      border-radius: var(--card-radius, 2rem);
    }
  }
}

// h5
.h5-org-List.org-List {
  padding: 0 12px 8px;

  // Horizontal scroll container
  .flex.overflow-x-auto {
    gap: 10px;
  }

  // Each org card — reduce width, fix border-radius (rem inflated)
  .min-w-\[85vw\] {
    min-width: 75vw !important;
    border-radius: 16px !important;
  }

  // Card top padding
  .pt-6.px-6.pb-2 {
    padding: 10px 12px 6px !important;
  }

  // Org logo — smaller
  .w-14.h-14 {
    width: 36px !important;
    height: 36px !important;
    border-radius: 8px !important;
    padding: 2px !important;
  }

  // Org name and info
  .flex.gap-4 {
    gap: 8px !important;
  }
  h3 {
    font-size: 14px !important;
    gap: 4px !important;
  }
  // Verified icon badge
  .p-1.bg-blue-50 {
    padding: 2px !important;
    svg {
      width: 8px !important;
      height: 8px !important;
    }
  }
  .text-xs.font-medium {
    font-size: 10px !important;
    gap: 4px !important;
    line-height: 1.6;
    margin: 0;
    margin-bottom: 4px;
  }
  // Description — limit to 1 line on mobile
  p.text-sm {
    font-size: 11px !important;
    margin-top: 2px !important;
    -webkit-line-clamp: 1 !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    overflow: hidden !important;
  }
  // Stats tags — more compact
  .flex.gap-2.mt-3 {
    margin-top: 4px !important;
    gap: 4px !important;
    span {
      font-size: 9px !important;
      padding: 1px 5px !important;
    }
  }

  // Action arrow button
  .w-9.h-9 {
    width: 24px !important;
    height: 24px !important;
    svg {
      width: 12px !important;
      height: 12px !important;
    }
  }

  // Recommended course bar at bottom
  .mt-auto.mx-2.mb-2 {
    margin: 0 6px 6px !important;
    .rounded-3xl {
      border-radius: 10px !important;
      padding: 6px 8px !important;
      gap: 6px !important;
    }
    .w-16.h-12 {
      width: 40px !important;
      height: 30px !important;
      border-radius: 6px !important;
    }
    // "精选推荐" label
    .text-\[10px\] {
      font-size: 8px !important;
    }
    h4 {
      font-size: 10px !important;
    }
    .text-sm.font-black {
      font-size: 11px !important;
    }
  }
}
</style>
